import React from 'react';
import { Modal, ModalHeader, ModalBody, Button } from 'reactstrap';

export const ModalLockedAssessment = ({ isOpen, close, blockDays }) => {

    return (
        <Modal isOpen={isOpen} toggle={close} centered size='md' className='close-circle'>
            <ModalHeader toggle={close} className='justify-content-center border-0 pb-0' cssModule={{'modal-title': 'modal-title libre-caslon-text-regular h4 mt-3'}}>Already Submitted</ModalHeader>
            <ModalBody className='text-center' >
                <p className='mb-4'>
                    {`You have already submitted your responses and they cannot be altered within ${blockDays} days of submission. For futher assistance, please reach out to us at `}
                    <a target='_blank' rel='noreferrer' href="mailto:accounts@trueadvance.com">accounts@trueadvance.com </a>
                    or through your designated True Advance point of contact.
                </p>
                <Button color='green-light' size='sm' onClick={close}>I Understand</Button>
            </ModalBody>
        </Modal>
    )
}